// extracted by mini-css-extract-plugin
export default {"root":"AuthForm_root__bKjY+","textField":"AuthForm_textField__WEKtJ","controls":"AuthForm_controls__yVVJf","form":"AuthForm_form__kV4hH","inputWrap":"AuthForm_inputWrap__lVpEB"};